import React, { useState, useEffect } from "react";
import { axiosReq } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { MainAdminTables, AddModalUniversity, DeleteModalWriters, UniversityTable } from "../../components"
import AddModalAdmin from "../../components/MainAdmin/Modals/AddModalAdmin";
import SettingModal from "../../components/MainAdmin/Modals/SettingModal";
import { useNavigate,useLocation } from "react-router-dom";
import Cookies from 'universal-cookie';
import FieldTables from "../../components/MainAdmin/Table/FieldTable";
import AddModalCollege from "../../components/MainAdmin/Modals/AddModalCollege";
import AddModalCollegeField from "../../components/MainAdmin/Modals/AddModalCollegeField";
import CollegeFieldTable from "../../components/MainAdmin/Table/CollegeFieldTable";
const MainAdminCollegeFields = () => {


    const titleRow = ["نام", "نام شهر", "کشور", "کاربر", "نام کاربری", "رمز عبور"];
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showSettingModal, setShowSettingModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [writersList, setWritersList] = useState([]);
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const [fields, setFields] = useState([]);
    const itemsPerPage = 10;
    const { state } = useLocation();

    let navigate = useNavigate();

    const GetData = async () => {
        const writersData = await axiosReq("CollegeField/GetCollegeFieldsByCollege?page=" + page + "&&pageSize=" + row + "&&search=" + search, "post",{collegeId:state.id});
        console.log(writersData)
        var selfield = [];

        const result = writersData?.data || writersData;
        (result?.data || []).forEach(element => {
            selfield.push({ name: element?.field.name, id: element?.collegeFieldId })
        });
        setWritersList(selfield)
        setCount(result?.count || 0)


        const dataCountry = await axiosReq("Field/GetFields", "get");
        var selCount = [];
        dataCountry.forEach(element => {
            selCount.push({ value: element.fieldId, label: element.name })
        });

        setFields(selCount)
    }
    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        console.log(token)
        console.log(cookies.get('role'))
        if (!token) {
            navigate("/");
        }
        else {
            //     if( cookies.get('role')=="Admin")
            //    {

            GetData()
            //    }


            //     else {
            //         navigate("/admin");

            //     }
        }
    }
    useEffect(() => {

        auth();
    }, [reCheck, search, page, row,]);


    // const currentItems = writersList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div>
            <div className="p-[20px] flex justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={'black'} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">دانشگاه</p>
                </div>
                <div className="flex justify-start items-center">
                    <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e) => setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search /></button>
                    </div>
                    <button className="w-[121px] h-[40px] hoverBgYellow bg-infinity-gradient shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </button>
                    <button onClick={() => setShowAddModal(true)} className="w-[154px] h-[40px] bg-infinity-gradient shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن رشته</p>
                    </button>
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px]">
                <CollegeFieldTable detail={true} edit={true} block={false} deleted={true} setting={true}
                    setShowEditModal={setShowEditModal} setShowBlockModal={setShowBlockModal}
                    setShowDeleteModal={setShowDeleteModal}
                    data={data} setData={setData}
                    setShowSettingModal={setShowSettingModal}
                    titleRow={titleRow} writersList={writersList}
                    count={count} page={page} setPage={setPage} row={row} setRow={setRow} /></div>


            {showAddModal ? 
            <AddModalCollegeField
id={state.id}
                fields={fields}
                title={'افزودن رشته جدید'} buttonName={'ثبت'} setShowModal={setShowAddModal} reCheck={reCheck} setRecheck={setRecheck}
                setSettingModal={setShowSettingModal} setData={setData} /> : null}
            {showEditModal ? <AddModalCollegeField id={state.id}
                fields={fields}
                title={'ویرایش'} buttonName={'ویرایش'} setShowModal={setShowEditModal} data={data} reCheck={reCheck} setRecheck={setRecheck} /> : null}
            {showDeleteModal ? <DeleteModalWriters title={'حذف رشته'} buttonName={'حذف'} text={'آیا از حذف رشته انتخاب شده اطمینان دارید ؟'}
                setShowModal={setShowDeleteModal} api={"CollegeField/DeleteCollegeField/" + data?.id} reCheck={reCheck} setRecheck={setRecheck} /> : null}
            {showSettingModal ? <SettingModal title={'مدیریت دسترسی'} buttonName={'ثبت'} setShowModal={setShowSettingModal} reCheck={reCheck} setRecheck={setRecheck} data={data} /> : null}

        </div>
    )
}

export default MainAdminCollegeFields;
